export default [
  {
    header: "إدارة واجهات الجمهور",
    icon: "UsersIcon",
    children: [
      {
        title: "لمحة عن المنظمة ",
        slug: "ngo_about_ngo",
        route: "about-ngo",
        icon: "AlignRightIcon",
      },
      
      {
        title: " فرص العمل ",
        slug: "opportunities",
        route: "job-vacancies-management",
        sub_route: "edit-jobs",
        sub_route2: "add-jobs",
        icon: "BriefcaseIcon",
      },
      {
        title: "فرص التطوع ",
        slug: "opportunities",
        route: "volunteer-vacancies-management",
        sub_route: "edit-volunteer",
        sub_route: "add-volunteer",
        icon: "AwardIcon",
      },
      {
        title: "الأخبار",
        slug: "news",
        route: "news-management",
        sub_route: "details-news",
        icon: "Volume2Icon",
      },
      {
        title: "الإحصائيات ",
        slug: "statistics",
        route: "statistics-management",
        icon: "BarChart2Icon",
      },
      {
        title: " الفعاليات",
        slug: "ngo-events",
        route: "events-management",
        icon: "CalendarIcon",
      },
      {
        title: "حملات التبرع",
        slug: "campaigns",
        route: "campaigns-management",
        icon: "UserCheckIcon",
      },
      {
        title: "معرض الصور",
        slug: "slide-images",
        route: "images-slider",
        icon: "ImageIcon",
      },

      {
        title: "رسائل الجمهور",
        slug: "ngo_public_messages",
        route: "guests-messages",
        icon: "MailIcon",
      },
      {
        title: "إدارة التبرع الالكتروني",
        slug: "ngo_payments",
        route: "payment-management",
        icon: "CreditCardIcon",
      },
    ],
  },
];
